
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind11 as ObiWind11Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-11.js';
 
 
 

 
 export const ObiWind11 = createComponent({
   react: React,
   tagName: 'obi-wind-11',
   elementClass: ObiWind11Element,
   events: {
     
   }
  });
 
 